/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const EnpsSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#FFEFDE" />
    <circle cx="12" cy="12" r="6.5" fill="#FFEFDE" stroke="#F6B673" />
    <circle
      cx="9.59375"
      cy="10.906"
      r="0.5"
      fill="#F6B673"
      stroke="#F6B673"
      strokeWidth="0.3125"
    />
    <circle
      cx="14.4062"
      cy="10.906"
      r="0.5"
      fill="#F6B673"
      stroke="#F6B673"
      strokeWidth="0.3125"
    />
    <path
      d="M8.91602 13.8516C10.4781 16.455 13.6021 16.455 15.1642 13.8516"
      stroke="#F6B673"
      strokeLinecap="round"
    />
  </svg>
)

const EnpsIcon = (props) => <Icon component={EnpsSvg} {...props} />

export { EnpsIcon }
